import { render, staticRenderFns } from "./UtilListingRedTractorAssured.vue?vue&type=template&id=0be46598&scoped=true"
import script from "./UtilListingRedTractorAssured.vue?vue&type=script&lang=js"
export * from "./UtilListingRedTractorAssured.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be46598",
  null
  
)

export default component.exports